// Single source of truth for TruWe customer-facing contact channels.
// Both the Contact page and the Track My Order page consume this so support
// numbers never drift.

export const TRUWE_CONTACT = {
  email: "hello@truwe.in",
  // Verified WhatsApp support line (E.164 without the leading +).
  whatsappNumber: "919258168191",
} as const;

/** Build a wa.me URL, optionally prefilling a message. */
export function whatsappSupportUrl(message?: string): string {
  const base = `https://wa.me/${TRUWE_CONTACT.whatsappNumber}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
